import React from 'react';
import { useDispatch } from 'react-redux';

import { MODAL_TEST_IDS } from 'apps/web_forms/utils/constants';
import { resetModal } from 'apps/web_forms/slices/appSlice';
import Modal from 'apps/web_forms/components/commons/Modal';

export const RangeFailureModal = ({ extraProps }) => {
  const { radius } = extraProps || {};
  const dispatch = useDispatch();

  return (
    <Modal
      mainMessage={`You must be within the range of ${radius.value} ${radius.unit} to send this form`}
      helpTip='Please get closer to the range and try again'
      isOpen={true}
      setIsOpen={() => dispatch(resetModal())}
      icon='error'
      testId={MODAL_TEST_IDS.RANGE_FAILURE_MODAL}
    />
  );
};
